import { render } from "./TextCarrousel.vue?vue&type=template&id=3b83b7c2"
import script from "./TextCarrousel.vue?vue&type=script&lang=js"
export * from "./TextCarrousel.vue?vue&type=script&lang=js"

import "./TextCarrousel.vue?vue&type=style&index=0&id=3b83b7c2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__